/* istanbul ignore file */
import React, { ReactElement } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import RapportApp from "./rapport-app/rapport-app";
// import "./styles/style.scss";
import {
  PagedReadyProvider,
} from "./contexts/paged-ready-context";
import { SettingsProvider } from "./shared/utils/settings-provider";

const App: React.FC = () => {
  return (
    <SettingsProvider loadingLogo={<>loading...</>}>
      <PagedReadyProvider>
        <BrowserRouter>
          <Switch>
            <Route
              path="/vestiging/:vestigingId/adviesdossier/:adviesdossierId/rapport/:rapportId"
              render={(): ReactElement => <RapportApp />}
            />
          </Switch>
        </BrowserRouter>
      </PagedReadyProvider>
    </SettingsProvider>
  );
};

export default App;
